'use client'

import { RefreshCcw } from 'lucide-react'

import { Button, Skeleton } from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

/** Loading placeholder for the badge grid — one skeleton per badge slot, sized to match `BadgeCard`. */
export function AchievementGridSkeleton() {
  return (
    <div className='srd:flex srd:flex-wrap srd:gap-3'>
      {Array.from({ length: 8 }).map((_, i) => (
        <Skeleton key={i} className='srd:size-[104px] srd:rounded-[16px]' />
      ))}
    </div>
  )
}

/** Error state shown when the achievement queries fail, with a retry action. */
export function AchievementLoadError({ onRetry, retrying }: { onRetry: () => void; retrying?: boolean }) {
  return (
    <div className='srd:flex srd:flex-col srd:items-center srd:gap-3 srd:py-12 srd:text-center'>
      <p className={cn(typographyVariants({ variant: 'body-sm' }), 'srd:text-grey-70')}>
        Gagal memuat. Silakan coba lagi.
      </p>
      <Button size='sm' variant='outline' onClick={onRetry} disabled={retrying}>
        <RefreshCcw className='srd:mr-2 srd:size-4' />
        Muat ulang
      </Button>
    </div>
  )
}

/** Empty state shown when the active filter has no badges to render. */
export function AchievementEmpty({ label }: { label: string }) {
  return (
    <div className='srd:flex srd:items-center srd:justify-center srd:py-16 srd:text-center'>
      <p className={cn(typographyVariants({ variant: 'body-md' }), 'srd:text-grey-60')}>{label}</p>
    </div>
  )
}
